import * as actionTypes from '../actionTypes';

const initialState = {
	primarySources: [],
};

function reducer(state = initialState, action) {
	switch (action.type) {
		case actionTypes.GET_PRIMARY_SOURCES_SUCCEED:
			return {
				...state,
				primarySources: action.payload
			};
		default:
			return state;
	}
}


export default reducer;
